/**
 * Feature flag system entry point.
 *
 * Importing this module (a side-effect import from the app entry point)
 * initializes the flag system: the background poller fetches the flag config
 * from `/feature-flags.json` and starts refreshing on a configurable interval
 * (`FEATURE_FLAG_POLL_INTERVAL`, default 30s).
 *
 * Flag evaluation (`isOn` / `flagEnabled`) is always synchronous and performs
 * no I/O. Consumers import those from `feature-flag-evaluator` directly. See
 * `feature-flag-evaluator.ts` (pure cache) and `feature-flag-poller.ts` (fetch).
 */

import { refreshFlags, startPoller } from 'utils/feature-flags/feature-flag-poller'

// Auto-initialize on import so the poller begins fetching the config at app
// startup. Flag reads default to false until the first fetch resolves.
// startPoller is idempotent if this module is evaluated more than once.
void refreshFlags()
startPoller()
